import { render, staticRenderFns } from "./Afterservicedetail.vue?vue&type=template&id=67f94c12&scoped=true&"
import script from "./Afterservicedetail.vue?vue&type=script&lang=js&"
export * from "./Afterservicedetail.vue?vue&type=script&lang=js&"
import style0 from "./Afterservicedetail.vue?vue&type=style&index=0&id=67f94c12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f94c12",
  null
  
)

export default component.exports